/* Klemons — Kauf-Block der Sets-Uebersicht: Umschalter Spar-Abo / Einmalkauf
   plus Liefertakt. Setzt je Set die selling_plan-Felder im Warenkorb-Formular. */
(function () {
  function wire(card) {
    if (card.dataset.spKaufInit) return;
    var form = card.querySelector('form[data-sp-form]');
    if (!form) return;
    var mode = form.querySelector('[data-sp-mode]');
    if (!mode) return;
    card.dataset.spKaufInit = '1';
    var takt = form.querySelector('[data-sp-takt]');

    function isAbo() {
      var r = mode.querySelector('input:checked');
      return !!r && r.value === 'abo';
    }
    function taktInput() {
      return takt ? takt.querySelector('input:checked') : null;
    }
    function paint() {
      var abo = isAbo();
      mode.querySelectorAll('.k-abo-wahl__opt').forEach(function (l) {
        var i = l.querySelector('input');
        l.classList.toggle('is-on', !!(i && i.checked));
      });
      if (takt) {
        takt.hidden = !abo;
        takt.querySelectorAll('.k-sp-takt-opt').forEach(function (l) {
          var i = l.querySelector('input');
          l.classList.toggle('is-on', !!(i && i.checked));
        });
      }
      var ti = taktInput();
      var aboTotal = ti ? ti.getAttribute('data-total') : null;
      var aboPrice = form.querySelector('[data-sp-abo-price]');
      if (aboPrice && aboTotal) aboPrice.textContent = aboTotal;
      var hint = card.querySelector('[data-sp-abo-hint]');
      if (hint && aboTotal) hint.textContent = aboTotal;
      var big = card.querySelector('[data-sp-total]');
      if (big) {
        var v = abo ? (aboTotal || big.getAttribute('data-abo')) : big.getAttribute('data-once');
        if (v) big.textContent = v;
      }
      var subOnce = card.querySelector('[data-sp-sub-once]');
      var subAbo = card.querySelector('[data-sp-sub-abo]');
      if (subOnce) subOnce.hidden = abo;
      if (subAbo) subAbo.hidden = !abo;
    }
    function sync() {
      var abo = isAbo();
      var ti = taktInput();
      var wanted = ti ? ti.value : '';
      form.querySelectorAll('[data-sp-plan]').forEach(function (slot) {
        var id = '';
        if (abo && wanted) {
          (slot.getAttribute('data-plans') || '').split(';;').forEach(function (pair) {
            var k = pair.indexOf('|');
            if (k > -1 && pair.slice(k + 1) === wanted) id = pair.slice(0, k);
          });
          if (!id && takt) {
            var idx = Array.prototype.indexOf.call(takt.querySelectorAll('input'), ti);
            var pairs = (slot.getAttribute('data-plans') || '').split(';;');
            if (pairs[idx]) id = pairs[idx].split('|')[0];
          }
        }
        if (id) {
          slot.value = id;
          slot.disabled = false;
        } else {
          slot.value = '';
          slot.disabled = true;
        }
      });
      paint();
    }

    mode.addEventListener('change', sync);
    if (takt) takt.addEventListener('change', sync);
    form.addEventListener('submit', sync, true);
    sync();
  }

  function init() {
    document.querySelectorAll('[data-sp-card]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();